/**
 * Cart checkout split: native /checkout vs Draft Order API.
 * Config: window.T4sMapDraftCheckout (set in main-cart section)
 * Cart totals: hooks fetch + XHR + jQuery.ajax + DOM observer (theme may not use fetch).
 */
(function () {
  'use strict';

  var CFG = window.T4sMapDraftCheckout || {};
  var apiUrl = (CFG.apiUrl || '').trim();
  var enabled = CFG.enabled !== false;
  var fetchPatched = false;
  var xhrPatched = false;
  var debounceTimer;

  function propMap(item) {
    var props = item.properties || {};
    var out = {};
    if (typeof props === 'object' && !Array.isArray(props)) {
      return props;
    }
    if (Array.isArray(props)) {
      props.forEach(function (row) {
        if (row && row.name != null) out[String(row.name)] = row.value;
      });
      return out;
    }
    return out;
  }

  function isCustomizedLineItem(item) {
    var p = propMap(item);
    if (p['Map customization'] && String(p['Map customization']).trim() !== '') return true;
    if (p['Map style price extra'] != null && String(p['Map style price extra']).trim() !== '') return true;
    if (p['Push pin price extra'] != null && String(p['Push pin price extra']).trim() !== '') return true;
    if (p['Map style'] != null && String(p['Map style']).trim() !== '') return true;
    if (p['Push pin style'] != null && String(p['Push pin style']).trim() !== '') return true;
    var k;
    for (k in p) {
      if (Object.prototype.hasOwnProperty.call(p, k) && k.indexOf('Map field ') === 0 && p[k] != null && String(p[k]).trim() !== '') {
        return true;
      }
    }
    return false;
  }

  function hasCustomizedCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    return cart.items.some(isCustomizedLineItem);
  }

  function parseMoneyExtra(val) {
    if (val == null || val === '') return 0;
    var n = parseFloat(String(val).replace(/[^0-9.-]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function estimatedCustomizationCents(cart) {
    var total = 0;
    if (!cart || !cart.items) return 0;
    cart.items.forEach(function (item) {
      var p = propMap(item);
      var line = parseMoneyExtra(p['Map style price extra']) + parseMoneyExtra(p['Push pin price extra']);
      var q = item.quantity || 1;
      total += Math.round(line * 100) * q;
    });
    return total;
  }

  function formatMoneyCents(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.T4Sconfigs && window.T4Sconfigs.moneyFormat) {
      try {
        return Shopify.formatMoney(cents, window.T4Sconfigs.moneyFormat);
      } catch (e) {}
    }
    return (cents / 100).toFixed(2);
  }

  /** Main cart form only (avoids wrong node if multiple cart UIs exist). */
  function getCartPageRoot() {
    var form = document.querySelector('form[data-cart-wrapper][data-cart-content]');
    if (form) return form;
    return document.querySelector('form[data-cart-wrapper]');
  }

  function updateEstimateDom(cart) {
    if (!cart) return;
    var base = cart.total_price || 0;
    var extra = estimatedCustomizationCents(cart);
    var estimated = base + extra;

    var root = getCartPageRoot();
    var scope = root || document;

    var estTop = scope.querySelector('[data-cart-subtotal-estimated]');
    if (estTop) estTop.textContent = formatMoneyCents(estimated);

    var estPanel = scope.querySelector('[data-cart-custom-estimate-total]');
    if (estPanel) {
      estPanel.textContent = formatMoneyCents(estimated);
      estPanel.setAttribute('data-extra-cents', String(extra));
    }

    var baseEl = scope.querySelector('[data-cart-base-subtotal]');
    if (baseEl) baseEl.textContent = formatMoneyCents(base);

    var extraEl = scope.querySelector('[data-cart-customization-extra]');
    if (extraEl) extraEl.textContent = formatMoneyCents(extra);

    var extraRow = scope.querySelector('[data-cart-customization-extra-row]');
    if (extraRow) extraRow.style.display = extra > 0 ? '' : 'none';

    if (!estTop) {
      var prices = scope.querySelector('[data-cart-prices]');
      if (prices) {
        var plain = prices.querySelector('.t4s-cart__totalPrice');
        if (plain && !plain.hasAttribute('data-cart-subtotal-estimated')) {
          plain.textContent = formatMoneyCents(cart.total_price || 0);
        }
      }
    }
  }

  /** QR / coupon code captured in the browser (typed value wins over stored one). */
  function getDiscountCode() {
    var input = document.getElementById('CartDiscountcode');
    if (input && input.value && input.value.trim()) return input.value.trim();
    try {
      if (window.T4sQrDiscount && window.T4sQrDiscount.get()) return window.T4sQrDiscount.get();
    } catch (e) {}
    try {
      return (window.localStorage.getItem('CartDiscountcode') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  function setAcceleratedCheckoutVisible(show) {
    document.querySelectorAll('.additional_checkout_buttons, [data-add-ckt4]').forEach(function (el) {
      el.style.display = show ? '' : 'none';
    });
  }

  function applyCartState(cart) {
    if (!cart) return;

    if (document.querySelector('[data-cart-has-customized]') && !hasCustomizedCart(cart)) {
      window.location.reload();
      return;
    }
    if (!document.querySelector('[data-cart-has-customized]') && hasCustomizedCart(cart)) {
      window.location.reload();
      return;
    }

    updateEstimateDom(cart);

    var custom = hasCustomizedCart(cart);
    var btn = document.querySelector('[data-cart-checkout-btn]');
    if (btn && CFG.strCustomizedCheckout) {
      btn.textContent = custom ? CFG.strCustomizedCheckout : CFG.strStandardCheckout || btn.getAttribute('data-label-default') || btn.textContent;
    }
    if (custom) setAcceleratedCheckoutVisible(false);
    else setAcceleratedCheckoutVisible(true);
  }

  function refreshFromCart() {
    fetchCart()
      .then(applyCartState)
      .catch(function () {});
  }

  function scheduleRefreshFromCart() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      refreshFromCart();
    }, 180);
  }

  function getFetchUrl(input) {
    if (typeof input === 'string') return input;
    if (input && input.url) return input.url;
    return '';
  }

  function cartAjaxUrlMatches(u) {
    return typeof u === 'string' && /\/cart\/(change|update|add)(\.js)?(\?|$)/.test(u);
  }

  function tryApplyCartJsonText(txt) {
    if (!txt || txt.charAt(0) !== '{') return;
    try {
      var data = JSON.parse(txt);
      if (data && typeof data.item_count !== 'undefined') {
        applyCartState(data);
      }
    } catch (e) {}
  }

  function patchFetchForCartAjax() {
    if (fetchPatched) return;
    fetchPatched = true;
    var ofetch = window.fetch;
    window.fetch = function (input, init) {
      return ofetch.apply(this, arguments).then(function (res) {
        var u = getFetchUrl(input);
        if (!cartAjaxUrlMatches(u) || !res.ok) return res;
        var ct = res.headers.get('content-type') || '';
        if (ct.indexOf('application/json') === -1) return res;
        res
          .clone()
          .json()
          .then(function (data) {
            if (data && typeof data.item_count !== 'undefined') {
              applyCartState(data);
            }
          })
          .catch(function () {});
        return res;
      });
    };
  }

  function patchXHRForCartAjax() {
    if (xhrPatched) return;
    xhrPatched = true;
    var proto = XMLHttpRequest.prototype;
    var origOpen = proto.open;
    var origSend = proto.send;

    proto.open = function (method, url) {
      this.__t4sCartAjaxUrl = typeof url === 'string' ? url : '';
      return origOpen.apply(this, arguments);
    };

    proto.send = function (body) {
      var self = this;
      var u = self.__t4sCartAjaxUrl || '';
      if (cartAjaxUrlMatches(u)) {
        self.addEventListener('load', function () {
          if (self.status < 200 || self.status >= 300) return;
          tryApplyCartJsonText(self.responseText);
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  function bindJQueryAjaxCartComplete() {
    var $ = window.jQuery || window.jQuery_T4NT || window.$;
    if (!$ || typeof $.fn === 'undefined' || !document.addEventListener) return;
    $(document).ajaxComplete(function (_event, xhr, settings) {
      var url = (settings && settings.url) || '';
      if (typeof url !== 'string') url = String(url || '');
      if (!cartAjaxUrlMatches(url)) return;
      if (xhr.status < 200 || xhr.status >= 300) return;
      var txt = xhr.responseText;
      if (!txt) {
        scheduleRefreshFromCart();
        return;
      }
      try {
        var data = JSON.parse(txt);
        if (data && typeof data.item_count !== 'undefined') {
          applyCartState(data);
        } else {
          scheduleRefreshFromCart();
        }
      } catch (e) {
        scheduleRefreshFromCart();
      }
    });
  }

  function bindCartItemsMutationObserver() {
    var items = document.querySelector('[data-cart-items]');
    if (!items || !window.MutationObserver) return;
    var obs = new MutationObserver(function () {
      scheduleRefreshFromCart();
    });
    obs.observe(items, { childList: true, subtree: true });
  }

  function bindQuantityInputRefresh() {
    var form = getCartPageRoot();
    if (!form) return;
    form.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.matches) return;
        if (t.matches('input[data-quantity-value], input[name="updates[]"]')) {
          scheduleRefreshFromCart();
        }
      },
      true
    );
  }

  function bindCheckoutIntercept(form) {
    if (!form || form.getAttribute('data-draft-checkout-bound')) return;
    form.setAttribute('data-draft-checkout-bound', '1');

    var allowNativeCheckout = false;

    form.addEventListener(
      'submit',
      function (e) {
        var sub = e.submitter;
        if (!sub || sub.name !== 'checkout') return;
        if (!enabled || !apiUrl) return;
        if (allowNativeCheckout) {
          allowNativeCheckout = false;
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        var prevText = sub.textContent;
        fetchCart()
          .then(function (cart) {
            if (!hasCustomizedCart(cart)) {
              allowNativeCheckout = true;
              if (typeof form.requestSubmit === 'function') {
                try {
                  form.requestSubmit(sub);
                } catch (err) {
                  allowNativeCheckout = true;
                  form.submit();
                }
              } else {
                allowNativeCheckout = true;
                form.submit();
              }
              return;
            }

            sub.disabled = true;
            sub.textContent = CFG.strCreating || 'Creating checkout…';

            return fetch(apiUrl, {
              method: 'POST',
              credentials: 'omit',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ cart: cart, shop: CFG.shop || (window.Shopify && window.Shopify.shop), discount_code: getDiscountCode() || undefined })
            })
              .then(function (r) {
                return r.json().then(function (data) {
                  if (!r.ok) throw new Error(data.message || data.error || 'draft_failed');
                  var url = data.invoice_url || data.invoiceUrl;
                  if (!url) throw new Error('no_invoice_url');
                  try {
                    sessionStorage.setItem(
                      't4s_last_draft_order',
                      JSON.stringify({ id: data.draft_order_id || data.draftOrderId, url: url, t: Date.now() })
                    );
                  } catch (err) {}
                  window.location.href = url;
                });
              })
              .catch(function () {
                alert(CFG.strError || 'Customized checkout failed. Please try again.');
                sub.disabled = false;
                sub.textContent = prevText;
              });
          })
          .catch(function () {
            sub.disabled = false;
            sub.textContent = prevText;
          });
      },
      true
    );
  }

  function bindCartRemoveAjax() {
    document.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest && e.target.closest('a[data-cart-remove]');
        if (!a) return;
        var form = document.querySelector('form[data-cart-wrapper]');
        if (!form || !form.contains(a)) return;
        e.preventDefault();
        e.stopPropagation();
        var key = a.getAttribute('data-id');
        if (!key) return;
        var row = a.closest('[data-cart-item]');
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('remove');
            return r.json();
          })
          .then(function (cart) {
            if (row && row.parentNode) row.parentNode.removeChild(row);
            if (!cart.item_count) {
              window.location.reload();
              return;
            }
            applyCartState(cart);
          })
          .catch(function () {
            window.location.href = a.href;
          });
      },
      true
    );
  }

  patchFetchForCartAjax();
  patchXHRForCartAjax();

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('form[data-cart-wrapper], form[action*="/cart"]');
    bindCheckoutIntercept(form);
    bindCartRemoveAjax();
    bindJQueryAjaxCartComplete();
    bindCartItemsMutationObserver();
    bindQuantityInputRefresh();
    refreshFromCart();

    document.addEventListener('cart:updated', refreshFromCart);
    document.addEventListener('cart:refresh', refreshFromCart);
  });
})();

